import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import OrderReviewIndexPage from '../containers/OrderReviews'

import appActions from '../redux/app/actions'

const { changeCurrent } = appActions

const OrderReviewsPage = ({
  location,
	match
}) => {
  const dispatch = useDispatch()
	const current = useSelector(state => state.getIn(['App', 'current'])).toJS()
	const { pathname } = location

	useEffect(() => {
		if (current[0] !== 'order_reviews') {
			dispatch(changeCurrent(['order_reviews']))
		}
	}, [pathname])

	const path = match.url

  return (
		<Switch>
			<Route path={`${path}/`} component={OrderReviewIndexPage} exact />
		</Switch>
  )
}

OrderReviewsPage.propTypes = {
  location: PropTypes.object.isRequired,
	match: PropTypes.object.isRequired
}

OrderReviewsPage.defaultProps = {}

export default OrderReviewsPage
